import React from 'react';
import PropTypes from 'prop-types';
import './page-header.scss';

const PageHeader = ({ currentPage, totalPages }) => (
  <h4 className="sm-page-header--heading" data-testid="PageHeader__Container">
    <hr className="sm-page-header--separator" />
    <div className="sm-page-header--count">
      Page {currentPage}/{totalPages}
    </div>
  </h4>
);

PageHeader.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
};

export default PageHeader;
